import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, effect, inject, input, model, output } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { DocumentiService } from 'src/app/core/documenti.service';
import { RevocaRequest } from 'src/app/shared/models/revocaRequest.model';

@Component({
  selector: 'app-revoca-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
  <p-dialog header="Annulla protocollo" [(visible)]="visible" [modal]="true" (onHide)="hide.emit()">
    <label for="dal" class="small-label">Il</label>
    <p-calendar [showIcon]="true" dateFormat="dd/mm/yy" [selectOtherMonths]="true" appendTo="body" [(ngModel)]="request.data"
      [inputStyle]="{'width': '187px'}">
    </p-calendar>
    <label for="note" class="small-label">Note</label>
    <textarea pInputTextarea id="note" class="text-area-dialog" [rows]="5" [cols]="30" [(ngModel)]="request.note" required></textarea>

    <p-footer>
      <button pButton type="button" icon="pi pi-times" label="Chiudi" (click)="hide.emit()"
        class="p-button-secondary"></button>
      <button pButton type="button" class="p-button-danger" icon="fas fa-fw fa-trash" label="Annulla" (click)="onRevokeClick()"
        [disabled]="!request.data || !request.note"></button>
    </p-footer>
  </p-dialog>
  `
})

export class RevocaDialogComponent {
  visible = model.required<boolean>();
  documentId = input<number | undefined>();
  hide = output();
  done = output();
  fail = output<HttpErrorResponse>();

  public request: RevocaRequest = {} as RevocaRequest;

  private documentiService = inject(DocumentiService);
  private confirmationService = inject(ConfirmationService);

  constructor() {
    effect(() => {
      if (this.visible()) {
        this.request = {
          data: new Date(),
          note: ''
        };
      }
    });
  }

  onRevokeClick() {
    if (!this.documentId()) return;

    this.confirmationService.confirm({
      header: 'Annullamento protocollo',
      icon: 'fas fa-fw fa-ban',
      message: `Sei sicuro di voler annullare il protocollo?`,
      accept: () => {
        this.documentiService.revoke(this.documentId()!, this.request)
          .subscribe({
            next: () => this.done.emit(),
            error: (error: HttpErrorResponse) => this.fail.emit(error),
            complete: () => this.hide.emit()
          });
      }
    });
  }
}
